import React from 'react'

// @todo More investigation needed for a better solution. See https://github.com/gatsbyjs/gatsby/pull/3483
// Always start at the top of the page on a route change.
export const onRouteUpdate = ({ location }) => {
  const { hash } = location
  if (hash) {
    const scrollToElement = document.querySelector(hash)
    if (scrollToElement) {
      scrollToElement.scrollIntoView({
        behavior: 'smooth',
      })
    }
  } else if (typeof window !== `undefined`) {
    window.scrollTo(0, 0)
  }
}

export const shouldUpdateScroll = args => {
  return false
}
